import { render, staticRenderFns } from "./ObtainCodeView.vue?vue&type=template&id=0922a787&scoped=true&"
import script from "./ObtainCodeView.vue?vue&type=script&lang=js&"
export * from "./ObtainCodeView.vue?vue&type=script&lang=js&"
import style0 from "./ObtainCodeView.vue?vue&type=style&index=0&id=0922a787&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922a787",
  null
  
)

export default component.exports